export function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}
export { _interop_require_default as _ };
